var _desc, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconCircleArrowRight(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "43px",
    height: "43px",
    viewBox: "0 0 43 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u8DEF\\u505C\\u7E73\\u8CBB-1-1",
    transform: "translate(-511.000000, -631.000000)",
    stroke: "#007AFF"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2-Copy-3",
    transform: "translate(37.000000, 597.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(475.000000, 35.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.7002,20.3501 C40.7002,31.5891 31.5892,40.7001 20.3502,40.7001 C9.1112,40.7001 0.0002,31.5891 0.0002,20.3501 C0.0002,9.1111 9.1112,0.0001 20.3502,0.0001 C31.5892,0.0001 40.7002,9.1111 40.7002,20.3501 Z",
    id: "Stroke-1",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Stroke-3",
    strokeWidth: 3,
    points: "22.5755 13.2572 29.6685 20.3502 22.5755 27.4422"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.6681,20.3498 L11.0321,20.3498",
    id: "Stroke-5",
    strokeWidth: 3
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCircleArrowRight);
export default __webpack_public_path__ + "static/media/icon_circle_arrow_right.41fb564a687ba9f44c13f4b53432c17b.svg";
export { ForwardRef as ReactComponent };